import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { AuthMFService } from '../util/otp/auth-mf.service';
import { LangueService } from '../services/langue/langue.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Injectable({
  providedIn: 'root',
})
export class HeadersInterceptor implements HttpInterceptor {
  private static readonly HEADER_ACCEPT_LANGUAGE = 'Accept-Language';
  private static readonly HEADER_AUTHORIZATION = 'Authorization';
  private static readonly HEADER_XDESJ_SOA = 'X-Desj-Envsoa';

  constructor(
    private readonly authMfService: AuthMFService,
    private readonly configService: ConfigurationService,
    private readonly langueService: LangueService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('devflix')) {
      return next.handle(request);
    }
    if (request.url.includes(this.configService.getValueOrBlank(configuration.ConfigMeta.OEL_PAAS_API_URL))) {
      return from(this.preparerRequest(request)).pipe(
        switchMap((requestModified) => {
          return next.handle(requestModified).pipe(
            tap((response) => {
              if (!(response instanceof HttpResponse)) {
                return;
              }

              const otpToken = response.headers.get(AuthMFService.AUTH_MF_HEADER);
              if (otpToken == null) {
                return;
              }

              this.authMfService.setOtpToken(otpToken);
            }),
            catchError((errorResponse) => {
              const otpToken = errorResponse.headers.get(AuthMFService.AUTH_MF_HEADER);
              if (otpToken != null) {
                this.authMfService.setOtpToken(otpToken);
              }

              return throwError(() => errorResponse);
            })
          );
        })
      );
    }
    return next.handle(request);
  }

  private async preparerRequest<T>(request: HttpRequest<T>): Promise<HttpRequest<T>> {
    const headers = await this.getHeaders(request.headers);
    return request.clone({ headers, withCredentials: true });
  }

  private async getHeaders(headers: HttpHeaders): Promise<HttpHeaders> {
    const token = await authentification.getAccessTokenContext();
    const langue = this.langueService.getCurrentLanguage();
    const otpToken: string | null = await this.authMfService.getOtpToken().catch((): null => null);
    const oelEnvsoa = this.configService.getValueOrBlank('oel-pise-envsoa');

    if (otpToken) {
      headers = headers.set(AuthMFService.AUTH_MF_HEADER, otpToken);
    }

    if (langue) {
      headers = headers.set(HeadersInterceptor.HEADER_ACCEPT_LANGUAGE, langue);
    }

    if (oelEnvsoa != null) {
      headers = headers.set(HeadersInterceptor.HEADER_XDESJ_SOA, oelEnvsoa);
    }

    headers = headers.set(HeadersInterceptor.HEADER_AUTHORIZATION, `Bearer ${token.signatureJWT}`);

    return headers;
  }
}
